import { Fingerprint } from "./fingerprint";
export interface SatelliteLockQuestion {
    question: string;
    response: string;
}
export interface SatelliteLockInspection {
    id?: string;
    version?: number;
    imei: string;
    evaluatorFingerPrint?: Fingerprint;
    confirmedInspectionFingerPrint?: Fingerprint;
    satelliteLockStructure: Array<SatelliteLockQuestion>;
    approval?: boolean;
    driverWarranty?: boolean;
}

export const DEVICE_REPORTING_OPTIONS: Array<{ value: string; label: string }> = [
    { value: 'SI', label: 'Sí' },
    { value: 'NO', label: 'No' }
];

export const DEVICE_CHARGE_LEVEL_OPTIONS: Array<{ value: string; label: string }> = [
    { value: 'LESS_THAN_25', label: 'Menor a 25%' },
    { value: 'GREATER_THAN_25', label: 'Entre 25% y 50%' },
    { value: 'GREATER_THAN_50', label: 'Entre 50% y 75%' },
    { value: 'BETWEEN_75_AND_100', label: 'Entre 75% y 100%' }
];
